export default HTTPClient => ({
  create: async ({
    studentExamId, beginDate, endDate, answersKeyReleaseDate, productId,
  }) => {
    const resp = await HTTPClient.post('sellable-student-exam', {
      body: JSON.stringify({
        student_exam_id: studentExamId,
        begin_date: beginDate,
        end_date: endDate,
        answers_key_release_date: answersKeyReleaseDate,
        product_id: productId,
      }),
    });
    return resp;
  },
  list: async (perPage, page, sortBy, order) => {
    let offset = 0;
    if (page !== 1) {
      offset = (page * perPage) - perPage;
    }
    const resp = await HTTPClient.get(`sellable-student-exam?limit=${perPage}&offset=${offset}&sort_by=${sortBy}&order=${order}`);
    return resp;
  },
  edit: async (id, { beginDate, endDate, answersKeyReleaseDate }) => {
    const resp = await HTTPClient.put(`sellable-student-exam/${id}`, {
      body: JSON.stringify({
        begin_date: beginDate,
        end_date: endDate,
        answers_key_release_date: answersKeyReleaseDate,
      }),
    });
    return resp;
  },
});
